import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Table, Tag, Row, Col, Statistic, Button, Icon } from 'antd'
import moment from 'moment'
import { useDeepEffect } from '../../utils/hooks'
import { fetchCouponReport } from '../../modules/reward'

const STATUS_TAG = {
  ISSUED: <Tag color="blue">ยังไม่เปิดใช้</Tag>,
  OPEN: <Tag color="orange">เปิดใช้แล้ว รอตัดสิทธิ์</Tag>,
  USED: <Tag color="green">ใช้แล้ว</Tag>,
  EXPIRED: <Tag color="red">หมดอายุ</Tag>
}

const formatDate = (value) =>
  value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'

/**
 * รายงานคูปอง (spec 013 P2)
 *
 * ตัวเลข breakage คือคูปองที่หมดอายุโดยไม่เคยเปิดใช้
 * นโยบายคือไม่คืนพอยท์ ตัวเลขนี้จึงเท่ากับพอยท์ที่ผู้ใช้เสียไปจริง
 */
const CouponReport = () => {
  const dispatch = useDispatch()

  const { couponReport, isLoading } = useSelector(
    (state) => ({
      couponReport: state.reward.couponReport,
      isLoading: state.reward.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    dispatch(fetchCouponReport())
  }, [])

  const summary = couponReport.summary || {}
  const breakagePercent = ((summary.breakageRate || 0) * 100).toFixed(1)
  const isBreakageHigh = Number(breakagePercent) >= 50

  const columns = [
    {
      title: 'รหัสคูปอง',
      dataIndex: 'couponCode',
      key: 'couponCode',
      render: (code) => <span style={{ fontFamily: 'monospace' }}>{code}</span>
    },
    { title: 'รางวัล', dataIndex: 'rewardName', key: 'rewardName' },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      render: (status) => STATUS_TAG[status] || <Tag>{status}</Tag>
    },
    {
      title: 'แลกเมื่อ',
      dataIndex: 'issuedAt',
      key: 'issuedAt',
      render: formatDate
    },
    {
      title: 'สิทธิ์หมดอายุ',
      dataIndex: 'expireAt',
      key: 'expireAt',
      render: formatDate
    },
    {
      title: 'ใช้เมื่อ',
      dataIndex: 'usedAt',
      key: 'usedAt',
      render: formatDate
    }
  ]

  return (
    <Card
      title="รายงานคูปอง"
      extra={
        <Button onClick={() => dispatch(fetchCouponReport())}>
          <Icon type="reload" /> รีเฟรช
        </Button>
      }>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Statistic title="คูปองที่ออกทั้งหมด" value={summary.issued || 0} />
        </Col>
        <Col span={6}>
          <Statistic title="ใช้แล้ว" value={summary.used || 0} />
        </Col>
        <Col span={6}>
          <Statistic
            title="หมดอายุโดยไม่เคยเปิดใช้"
            value={summary.expiredUnopened || 0}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="อัตราคูปองสูญเปล่า"
            value={breakagePercent}
            suffix="%"
            valueStyle={{ color: isBreakageHigh ? '#f5222d' : undefined }}
          />
        </Col>
      </Row>

      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={couponReport.items || []}
        scroll={{ x: 900 }}
      />
    </Card>
  )
}

export default CouponReport
